module.exports = __webpack_public_path__ + "img/main-mobile.aac8cad8.png";